var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadLast } from "framework/state/loader";
import { NoEntityError } from "framework/validation/validatableentity";
import { updateByCollectionResponse } from "framework/state/collection";
import { apiGetCompetitions } from "../../endpoint";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), valid: true, orderBy: "type" });
var invalidate = function () { return function (store) {
    store.setState(function (draft) {
        draft.valid = false;
    });
}; };
var loadCompetitions = function (eventId, eventCompetitionId, order) { return function (store) {
    var filter = "eventCompetitionId=".concat(eventCompetitionId);
    var loader = function () { return apiGetCompetitions(eventId, filter, order); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft, response);
            draft.valid = true;
        });
    };
    loadLast(store, loader, stateProducer);
}; };
var setCompetitionsOrder = function (order) { return function (store) {
    store.setState(function (draft) {
        draft.orderBy = order;
    });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadCompetitions: loadCompetitions,
        invalidate: invalidate,
        setCompetitionsOrder: setCompetitionsOrder,
    },
    name: "EventCalendarCompetitions"
});
var useState = createHook(store);
export { useState as useEventCalendarCompetitions, };
